import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Card, Input, Button, SelectBox } from "components/src";
import { FormProvider, useForm } from "react-hook-form";
import { Col, Form, Radio, Row } from "antd";
import { Controller } from "../../molecules";
import {
  useLanguage,
} from "core";

const TITLE = "title";
const NAMEANDFAMILY = "nameAndFamily";
const USERNAME = "userName";
const MOBILENUMBER = "mobileNumber";


interface AdvanceFilterProps {
  setAdvanceFilter: (values: {
    title:string;
    nameAndFamily: string;
    userName: string;
    mobileNumber: string;
  }) => void;
  titleField?:boolean;
  nameAndFamilyField?: boolean;
  userNameField?: boolean;
  mobileNumberField?: boolean;
}

const AdvanceFilter: React.FC<AdvanceFilterProps> = ({
  setAdvanceFilter,
  titleField,
  nameAndFamilyField,
  userNameField,
  mobileNumberField,
}) => {
  const { i18n } = useTranslation();
  const { isRtl } = useLanguage();

  

  // const {
  //   data: { data: serverIpData } = {},
  //   isFetching: ServerLoading,
  // } = useGetServerIpForSelect({
  //   refetchOnWindowFocus: false,
  // });

  const methods = useForm({
    defaultValues: {
      title:"",
      nameAndFamily: "",
      userName: "",
      mobileNumber: "",
    },
  });

  const { handleSubmit, getValues, reset } = methods;

  const handleFilter = () => {
    const values = getValues();
    setAdvanceFilter?.(values);
  };

  const handleReset = () => {
    reset({
      title:"",
      nameAndFamily: "",
      userName: "",
      mobileNumber: "",
    });
  };

  
  // const creatorOptions = useMemo((): any[] => {
  //   return data?.map((item: any) => {
  //     return {
  //       value: item.id,
  //       label: item.name,
  //     };
  //   });
  // }, [data]);

  // const serverOption = useMemo((): any[] => {
  //   return serverIpData?.map((item: any) => {
  //     return {
  //       value: item.id,
  //       label: item.name,
  //     };
  //   });
  // }, [serverIpData]);

  // const isLoading = isFetching;

  return (
    <>
      <Card title={i18n.t("advanceSearch")}>
        <FormProvider {...methods}>
          <Form onFinish={handleSubmit(handleFilter)}>
            <Row gutter={16}>

              {titleField && (
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item>
                    <Controller name={TITLE}>
                      <Input placeholder={i18n.t("name")} />
                    </Controller>
                  </Form.Item>
                </Col>
              )}

              {nameAndFamilyField && (
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item>
                    <Controller name={NAMEANDFAMILY}>
                      <Input placeholder={i18n.t("nameAndFamily")} />
                    </Controller>
                  </Form.Item>
                </Col>
              )}

              {userNameField && (
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item>
                    <Controller name={USERNAME}>
                      <Input placeholder={i18n.t("userName")} />
                    </Controller>
                  </Form.Item>
                </Col>
              )}

            
              {mobileNumberField && (
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item>
                    <Controller name={MOBILENUMBER}>
                      <Input placeholder={i18n.t("mobileNumber")} />
                    </Controller>
                  </Form.Item>
                </Col>
              )}

              <Col xs={24}></Col>
              <Col xs={24} sm={6} md={4} lg={3} xl={3} xxl={2}>
                <Button
                  style={{ backgroundColor: "gray" }}
                  onClick={handleReset}
                >
                  {i18n.t("reset")}
                </Button>
              </Col>
            </Row>
            <Col xs={24} sm={6} md={4} lg={3} xl={3} xxl={2}>
              <Button htmlType="submit">{i18n.t("search")}</Button>
            </Col>
          </Form>
        </FormProvider>
      </Card>
    </>
  );
};

export { AdvanceFilter };
